import { useMessages } from "../language/language"
import ScreenPage from "../screens/screen-page"
import Layout from "../layouts/layout"
import { serverGetLatestPreviewScreen } from "utils/server"
import LoadingPage from "../frames/loading-frame"
import { useEffect, useRef } from "react"
import { useParams } from "react-router-dom"
import { random } from "utils/helpers"
import { usePlayState } from "play/hooks/use-play-state"
import { lessonScreenToClientScreen, PlayHubState } from "play/play-model"
import { applyScreenToState } from "play/reducers"

export default function PreviewScreenPage() {
  const { lessonId } = useParams()
  const msg = useMessages()
  const { screen, serverError, modifyState } = usePlayState()
  const timerId = useRef<number>(0)
  const isQuitting = useRef<boolean>(false)
  const failedCount = useRef(0)

  useEffect(() => {
    modifyState((state) => {
      state.isPreview = true
    })
  }, [])

  useEffect(() => {
    function refresh() {
      // console.log('refresh')

      return serverGetLatestPreviewScreen(lessonId!)
        .then((resp) => {
          // console.log('resp', resp)
          if (!resp.latest) {
          } else {
            modifyState((state) => {
              state.internalPage = null
              state.serverError = null

              // store debug properties
              const propertiesToPreserve: [keyof PlayHubState] = [
                "showCorrectAnswers",
              ]
              const oldValues: Partial<PlayHubState> = {}
              for (const prop of propertiesToPreserve) {
                ;(oldValues as any)[prop] = state[prop] as any
              }

              const clientScreen = lessonScreenToClientScreen(
                resp.latest!.screen
              )
              clientScreen.currentScreen = resp.latest!.screen.ordinal + 1
              state.countScreens = 1

              state.isBusinessVersion = resp.isBusinessVersion
              state.theme = resp.latest?.theme || null

              applyScreenToState(state, clientScreen)

              // restore debug properties
              for (const prop of propertiesToPreserve) {
                ;(state as any)[prop] = oldValues[prop]
              }
            })
          }
        })
        .catch((e) => {
          console.log("preview failed", e)
          modifyState((state) => {
            state.internalPage = null
            state.serverError = "Generic"
            state.serverErrorData = e
            state.screen = null
          })
          failedCount.current++
          if (failedCount.current > 3) {
            isQuitting.current = true
          }
        })
    }

    function ping() {
      // console.log('ping', isQuitting.current)
      if (isQuitting.current) return

      timerId.current = setTimeout(
        () => {
          // console.log('ping timeout', isQuitting.current)
          if (isQuitting.current) return

          refresh().then(() => {
            ping()
          })
        },
        random(500, 1000)
      ) as any
    }

    failedCount.current = 0
    isQuitting.current = false
    ping()

    return () => {
      isQuitting.current = true
      clearTimeout(timerId.current)
    }
  }, [lessonId])

  if (!screen) {
    return <LoadingPage />
  } else if (serverError !== null) {
    return (
      <Layout>
        <p className="error">
          {msg.serverErrorToString(serverError || "Generic")}
        </p>
      </Layout>
    )
  } else {
    return <ScreenPage screen={screen} />
  }
}
